export default "__VITE_ASSET__BQ9JcY2Y__"